<div>
    <h4>
        You must acknowledge the following {{notes.length > 1 ? notes.length + ' notes' : 'note'}} to sign on
    </h4>
    <p-card header="{{note.noteTime | date: 'HH:mm'}} by {{note.createdBy.firstName}} {{note.createdBy.lastName}}">
        <ng-container (container)="setupNoteViewContainer($event)"></ng-container>
        <div *ngIf="note.noteComments.length">
            <p-divider></p-divider>
            <h5>Note Comments</h5>
        </div>
        <div *ngFor="let comment of note.noteComments">
            <label>
                {{comment.updatedBy.firstName}} {{comment.updatedBy.lastName}}
                commented at
                {{comment.updated | date: 'HH:mm'}}
            </label>
            <br>
            {{comment.comment}}
        </div>
        <ng-template pTemplate="footer">
            <div class="p-text-center">
                <button pButton label="Acknowledge" [disabled]="updatePending" (click)="acknowledge(note)"></button>
            </div>
        </ng-template>
    </p-card>
</div>